import axios from "axios";
import CommonHeader from "../utils/commonHeader";


export async function getAuthToken( ) {
  const objectID =process.env.REACT_APP_OBJECT_ID_PROD;
  const authId = btoa(process.env.REACT_APP_AUTH_BASIC);
  const url = process.env.REACT_APP_OPEN_SESSION_URL;
 
  try {
    const response = await axios.get(
      url,
      {
        headers: {
          id: objectID,
          Authorization: `Basic ${authId}`,
        }
      }
    );   

    return response.data;
  } catch (err) {
    console.error("Auth Error:", err);
    throw new Error("Failed to fetch auth token");
  }
}


